<template>
    <div class="container">
        <BlogPageBuilder :response="response"></BlogPageBuilder>
    </div>
</template>

<script>
import { BlogPageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'SustainabilityPage',
    data() {
        return {
            page_title: 'Sustainability',
            response: [],
        };
    },
    created() {
        getButterCmsPage('sustainability').then((res) => this.response = res);
    },
    components: {
        BlogPageBuilder,
    },
};
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        max-width: 100%;
        padding-top: 64px;
    }
</style>
